;
(function(){
var $=function(s,r){return(r||document).querySelector(s)};
var $$=function(s,r){return Array.from((r||document).querySelectorAll(s))};
var w=$('#ffq'),intro=$('.intro',w),qz=$('.qz',w),steps=$$('.step',w),
nb=$('#ffqN',w),fill=$('#ffqF',w),mE=$('#fM',w),pE=$('#fP',w),qH=$('#fQ',w),qSb=$('#fS',w),
eScr=$('#ffqE',w),l1=$('#L1',w),l2=$('#L2',w),res=$('.R',w);
var idx=0,A={},advancing=false;

function trk(e,p){if(typeof gtag==='function')gtag('event',e,p||{})}
function pct(n){return Math.round(((n+1)/steps.length)*100)}
function hdr(n){var p=pct(n);fill.style.width=p+'%';mE.textContent='Question '+(n+1)+' of '+steps.length;pE.textContent=p+'%';qH.textContent=steps[n].dataset.title||'';qSb.textContent=steps[n].dataset.sub||''}
function show(n){steps.forEach(function(s,x){s.classList.toggle('h',x!==n)});hdr(n);upd(steps[n]);syn(steps[n]);nb.textContent=(n===steps.length-1)?'See My Results':'Next';
  nb.style.display=(steps[n].dataset.type==='radio')?'none':'block';
  window.scrollTo({top:0,behavior:'smooth'});}
function upd(s){nb.disabled=!$$('input',s).some(function(x){return x.checked})}
function syn(s){$$('.o',s).forEach(function(o){var x=$('input',o);o.classList.toggle('sel',x&&x.checked)})}
function eMax(s,c){var m=parseInt(s.dataset.max||'0',10);if(!m)return;if($$('input[type="checkbox"]',s).filter(function(x){return x.checked}).length>m)c.checked=false}
function col(n){var s=steps[n];var c=$$('input:checked',s);var v=c.map(function(x){return x.value});A['q'+(n+1)]=v;return v.join(', ')}

function advance(){
  if(advancing)return;advancing=true;
  var ans=col(idx);trk('quiz_step_complete',{step_number:idx+1,step_title:steps[idx].dataset.title||'',answers:ans});
  if(idx<steps.length-1){idx++;show(idx)}
  else{qz.classList.add('h');eScr.classList.remove('h');window.scrollTo({top:0,behavior:'smooth'})}
  setTimeout(function(){advancing=false},500);
}

steps.forEach(function(s,sIdx){
  $$('input',s).forEach(function(x){
    x.addEventListener('change',function(e){
      if(sIdx===3){
        var isNothing=e.target.value==='Nothing';
        if(isNothing&&e.target.checked){
          $$('input[type="checkbox"]',s).forEach(function(cb){if(cb!==e.target)cb.checked=false});
        }else if(!isNothing&&e.target.checked){
          var noth=$('input[value="Nothing"]',s);if(noth)noth.checked=false;
        }
      }
      if(s.dataset.max)eMax(s,e.target);
      upd(s);syn(s);
      if(s.dataset.type==='radio'){setTimeout(advance,400)}
    });
  });
});

$('#ffqS',w).addEventListener('click',function(){trk('quiz_start');intro.classList.add('h');qz.classList.remove('h');idx=0;
  fill.style.transition='none';fill.style.width='0%';fill.offsetWidth;fill.style.transition='';
  setTimeout(function(){show(0)},50);
});
nb.addEventListener('click',advance);

$('#eB',w).addEventListener('click',function(){
  var em=$('#eI',w).value.trim();if(!em||em.indexOf('@')<1){$('#eI',w).style.borderColor='#e53e3e';return}
  trk('quiz_email_captured',{email_provided:true});A.email=em;goLoad();
});
$('#eSk',w).addEventListener('click',function(){trk('quiz_email_skipped');goLoad()});

function goLoad(){
  eScr.classList.add('h');l1.classList.remove('h');
  setTimeout(function(){l1.classList.add('h');l2.classList.remove('h');
    setTimeout(function(){
      l2.classList.add('h');
      build();
      res.classList.remove('h');
      w.style.overflow='auto';
      w.style.height='auto';
      trk('quiz_complete',{pain_area:g('q1'),duration:g('q2'),impact:(A.q3||[]).join(', '),commitment:g('q6')});
      window.scrollTo({top:0,behavior:'smooth'});
    },1400);
  },1400);
}
function g(k){return(A[k]&&A[k][0])||''}

function build(){
  var q1=g('q1'),q2=g('q2'),q3=A.q3||[],q4=A.q4||[],q5=A.q5||[],q6=g('q6'),q7=A.q7||[];
  function has3(v){return q3.indexOf(v)>-1}
  function has7(v){return q7.indexOf(v)>-1}

  var loc={'Neck and shoulders':'neck and shoulder','Upper back':'upper back','Lower back':'lower back','Hips and glutes':'hip and glute','Full body':'full-body','Tension':'tension'};
  var locW=loc[q1]||'';
  var locFull={'Neck and shoulders':'neck and shoulder pain','Upper back':'upper back pain','Lower back':'lower back pain','Hips and glutes':'hip and glute pain','Full body':'full-body pain','Tension':'built-up tension'};
  var locF=locFull[q1]||'pain';

  var ti='This is how the pain finally ends.';
  if(q1==='Lower back')ti='This is how your lower back pain finally ends.';
  else if(q1==='Neck and shoulders')ti='This is how your neck and shoulder pain finally ends.';
  else if(q1==='Upper back')ti='This is how your upper back pain finally ends.';
  else if(q1==='Hips and glutes')ti='This is how your hip and glute pain finally ends.';
  else if(q1==='Full body')ti='This is how you finally get your body back.';
  else if(q1==='Tension')ti='This is how you finally release the tension for good.';
  $('#rT',w).textContent=ti;

  var a='';
  if(q1==='Tension'){
    a='You\'ve been carrying tension and stress'+durText(q2)+', and it\'s wearing you down. ';
    a+=triedShort(q4);
    a+='The Bliss Pro delivers deep tissue massage with heat therapy — 15 minutes a day, every day, right at home.';
  }else{
    a='You\'ve been dealing with '+locF+durText(q2);
    if(has3('Sleep'))a+=', and it\'s costing you sleep';
    else if(has3('Constant'))a+=', and you\'ve almost given up on finding a fix';
    else if(has3('Morning'))a+=', and every morning is a struggle';
    else if(has3('Activity'))a+=', and it\'s taken away things you love';
    else if(has3('Sitting'))a+=', and sitting all day makes it worse';
    a+='. ';
    a+=triedShort(q4);
    a+='The Bliss Pro targets your '+locW+' area with deep tissue precision — 15 minutes a day, on your schedule.';
  }

  function durText(d){
    if(d==='Weeks')return ' for a few weeks';
    if(d==='Months')return ' for months';
    if(d==='Year')return ' for over a year';
    if(d==='Years')return ' for years';
    return '';
  }
  function triedShort(tried){
    if(!tried||tried.length===0||tried[0]==='Nothing')return '';
    var names=[];
    if(tried.indexOf('Chiro')>-1)names.push('chiropractors');
    if(tried.indexOf('Massage')>-1)names.push('massage therapy');
    if(tried.indexOf('Meds')>-1)names.push('painkillers');
    if(tried.indexOf('Stretch')>-1)names.push('stretching');
    if(tried.indexOf('Heat')>-1)names.push('heat pads');
    if(names.length===0)return '';
    var tr=names.length===1?names[0]:names.slice(0,-1).join(', ')+' and '+names[names.length-1];
    return 'You\'ve tried '+tr+' without lasting results. ';
  }

  $('#rA',w).textContent=a;

  var tg='Personalized to your body. Built for daily relief.';
  if(q1==='Lower back')tg='Targeted lower back and glute relief. Every day.';
  else if(q1==='Neck and shoulders')tg='Deep neck and shoulder therapy. On your schedule.';
  else if(q1==='Full body')tg='Head-to-toe relief. One chair. 15 minutes.';
  else if(q1==='Hips and glutes')tg='Hip, glute, and lower body relief. Daily.';
  else if(q1==='Upper back')tg='Upper back and posture relief. Every session.';
  $('#rTg',w).textContent=tg;

  var bs=[];
  bs.push('Targets your '+locW+' area with deep tissue precision — daily, on your schedule.');
  if(q4.indexOf('Chiro')>-1||q4.indexOf('Massage')>-1)bs.push('Same techniques your therapist uses. Every day instead of once a week. No scheduling, no driving, no $80 per visit.');
  else if(q4.indexOf('Meds')>-1)bs.push('Works directly on the tight muscles causing the pain instead of masking it. Most people reduce painkillers within weeks.');
  else bs.push('Heat therapy loosens tight muscles before the massage — the same approach therapists use.');
  bs.push('89% of customers report noticeable relief within the first week.');
  bs.push('15 minutes a day. No appointments. No commute. No co-pays.');

  var bh='';bs.forEach(function(b){bh+='<div class="rb">'+b+'</div>'});
  $('#rB',w).innerHTML=bh;

  var ts={
    chronic:{q:'After just a few nights, my back feels completely different. Getting out of bed is finally easy again. I wish I\'d done this years ago.',n:'Cyndie, 53',tg:'Chronic Back Pain'},
    injury:{q:'My back was ruined after my injury and this chair has helped fix it. Can\'t recommend enough.',n:'David, 56',tg:'Back Injury Recovery'},
    sport:{q:'This helped my back a ton which was not in good shape from my hockey injury. Highly recommend.',n:'Liam, 28',tg:'Sports Recovery'},
    relax:{q:'This is the best thing in the world to use to relax. I use it every night when watching TV.',n:'Vuk, 24',tg:'Daily Relaxation'},
    chiro:{q:'I was spending $300 a month on massage appointments. Now I get better results at home every single day.',n:'Margaret, 61',tg:'Former Massage Client'}
  };
  var te;
  if(q4.indexOf('Chiro')>-1||q4.indexOf('Massage')>-1)te=ts.chiro;
  else if(has3('Sleep')||has3('Morning'))te=ts.chronic;
  else if(has3('Activity'))te=ts.sport;
  else if(has3('Stress')||q1==='Tension')te=ts.relax;
  else if(q1==='Lower back'||q1==='Full body')te=ts.chronic;
  else te=ts.injury;
  $('#rTe',w).innerHTML='<div class="stars">★★★★★</div><p>"'+te.q+'"</p><div class="tn">— '+te.n+' · '+te.tg+'</div>';

  var pr='';
  if(has7('Monthly')&&!has7('Full')){
    pr+='<div class="pp">$208/mo at 0% interest</div>';
    pr+='<div class="ps">$2,499.99 total · Split into easy monthly payments, no hidden fees</div>';
    if(has7('Trial'))pr+='<div class="pt">Includes 90-day home trial — if it doesn\'t work, send it back for a full refund</div>';
  }else if(has7('Full')&&!has7('Monthly')){
    pr+='<div class="pp">$2,499.99</div>';
    pr+='<div class="ps">One-time payment · Or split into $208/mo at 0% interest</div>';
    if(has7('Trial'))pr+='<div class="pt">Includes 90-day home trial — if it doesn\'t work, send it back for a full refund</div>';
  }else if(has7('Trial')&&!has7('Monthly')&&!has7('Full')){
    pr+='<div class="pp">90-Day Home Trial</div>';
    pr+='<div class="ps">$2,499.99 or $208/mo at 0% interest · Try it for 90 days, return it for a full refund if it doesn\'t work</div>';
  }else{
    pr+='<div class="pp">$208/mo at 0% interest</div>';
    pr+='<div class="ps">$2,499.99 total · 0% interest financing · 90-day home trial included</div>';
  }
  $('#rPr',w).innerHTML=pr;

  var ctaText='View Your Recommended Chair →';
  if(has7('Trial')&&!has7('Monthly')&&!has7('Full'))ctaText='Start Your 90-Day Home Trial →';
  $('#rC',w).textContent=ctaText;
  $('#rC2',w).textContent=ctaText;

  $('#rSt',w).innerHTML='<div class="si"><strong>89%</strong>reported relief within the first week</div><div class="si"><strong>2,000+</strong>Canadians trust it</div><div class="si"><strong>4.8★</strong>average rating</div>';

  var t1='Your '+locW+' muscles start releasing built-up tension. Most people feel looser after the very first session.';
  var t2='Sessions start compounding. The stiffness that ';
  if(has3('Sleep'))t2+='ruins your sleep';
  else if(has3('Morning'))t2+='makes mornings a struggle';
  else if(has3('Sitting'))t2+='builds from sitting all day';
  else if(has3('Activity'))t2+='holds you back';
  else t2+='you carry all day';
  t2+=' begins fading.';
  var t3='Deep, sustained relief sets in. Your body holds its relaxed state between sessions instead of seizing back up.';
  var t4='Consistent daily use keeps your muscles loose and pain-free. This is the long-term fix.';
  if(q1==='Tension'){t1='Your muscles start releasing built-up tension and stress. Most people feel a real difference after the very first session.';}

  var tl='<div class="tl-h">What to expect</div><div class="tl-grid">';
  tl+='<div class="tl-item"><div class="tl-n">01</div><div class="tl-d">Day 1–3</div><div class="tl-t">'+t1+'</div></div>';
  tl+='<div class="tl-item"><div class="tl-n">02</div><div class="tl-d">Day 4–7</div><div class="tl-t">'+t2+'</div></div>';
  tl+='<div class="tl-item"><div class="tl-n">03</div><div class="tl-d">Week 2–3</div><div class="tl-t">'+t3+'</div></div>';
  tl+='<div class="tl-item"><div class="tl-n">04</div><div class="tl-d">Ongoing</div><div class="tl-t">'+t4+'</div></div>';
  tl+='</div>';
  $('#rTl',w).innerHTML=tl;

  var cg='';
  if(has7('Trial')){
    cg+='<div class="rci"><strong>90-Day Home Trial</strong>Buy it, try it for 90 days. If it doesn\'t fix your pain, we\'ll pick it up and refund every penny. No questions asked.</div>';
    cg+='<div class="rci"><strong>0% Interest Financing</strong>$208/mo with 0% interest. No hidden fees, no balloon payments.</div>';
  }else if(has7('Monthly')){
    cg+='<div class="rci"><strong>0% Interest Financing</strong>$208/mo with 0% interest. No hidden fees, no balloon payments.</div>';
    cg+='<div class="rci"><strong>90-Day Home Trial</strong>Buy it, try it for 90 days. If it doesn\'t fix your pain, we\'ll pick it up and refund every penny.</div>';
  }else{
    cg+='<div class="rci"><strong>90-Day Home Trial</strong>Buy it, try it for 90 days. If it doesn\'t fix your pain, we\'ll pick it up and refund every penny.</div>';
    cg+='<div class="rci"><strong>0% Interest Financing</strong>$208/mo with 0% interest. No hidden fees, no balloon payments.</div>';
  }
  cg+='<div class="rci"><strong>Ready Tonight</strong>No tools, no assembly, no waiting. Plug it in and feel relief tonight.</div>';
  cg+='<div class="rci"><strong>3-Year Full Warranty</strong>Your investment is protected. Full parts coverage and lifetime customer support.</div>';
  $('#rCg',w).innerHTML=cg;

  if(A.email){$('#rCs',w).textContent='Your results have been saved to your email';$('#rCs2',w).textContent=''}
  else{$('#rCs',w).textContent='90-day trial · 0% financing · 3-year warranty';$('#rCs2',w).textContent=''}

  function go(){trk('quiz_cta_click',{pain_area:q1,duration:q2,commitment:q6,payment:(A.q7||[]).join(', ')});window.location.href='https://forwardfurniture.ca/products/bliss-leather-heated-massage-chair'}
  $('#rC',w).addEventListener('click',go);$('#rC2',w).addEventListener('click',go);
}
show(0);fill.style.width='0%';
})();
